/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {DataStore, Storage, SortDirection} from 'aws-amplify';
import {Journey, JourneyStage, JourneyCheckpoint} from '../models';
import PropTypes from 'prop-types';
import QRCode from '../images/qrcode/downloadApp.png';
import {isDesktop, isIOS} from 'react-device-detect';
/**
 * @param {string} id
 * @param {boolean} journeyDemoVisibility
 * @param {function} setJourneyDemoVisibility
 * @return {JourneyDemo}
 */
function JourneyDemo({id, journeyDemoVisibility, setJourneyDemoVisibility}) {
  /* init function */
  useEffect(()=>{
    if (id != '' && id != undefined) {
      getJourney();
    }
  }, [id]);
  /* to get journey details */
  const [journeyArray, setJourneyArray] = useState([]);
  const [journeyImageArray, setJourneyImageArray] = useState([]);
  const [journeyCheckpointArray, setJourneyCheckpointArray] = useState([]);
  const [journeyCheckpointAudio, setJourneyCheckpointAudio] = useState();
  const [activeKey, setActiveKey] = useState(0);
  const [showAll, setShowAll] = useState(true);
  const toDownloadAppIOS = () => {
    window.location.href = 'https://apps.apple.com/hk/app/vivablee/id1551773278';
  };
  const toDownloadAppAndroid = () => {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.vivableeraw';
  };
  const getJourney = async () => {
    /* to get the journ ey details */
    const journeyList = await DataStore.query(Journey, id);
    setJourneyArray(journeyList);
    /* to get the journey image url */
    for (let i = 0; i < journeyList.imagesLarge.length; i++) {
      getDataStoreURL(journeyList.imagesLarge[i]).then((response)=>{
        // eslint-disable-next-line max-len
        setJourneyImageArray((journeyImageArray) => [...journeyImageArray, response]);
      });
    }
    /* to get the journey stage details */
    const journeyStageList = await DataStore.query(
        JourneyStage,
        (c) => c.journeyID('eq', id),
        {
          sort: (s) => s.order(SortDirection.ASCENDING),
        },
    );
    /* to get the checkpoint details */
    for (let i = 0; i < journeyStageList.length; i++) {
      const journeyCheckpointList = await DataStore.query(
          JourneyCheckpoint,
          (c) => c.journeystageID('eq', journeyStageList[i].id),
          {
            sort: (s) => s.order(SortDirection.ASCENDING),
          },
      );
      for (let j = 0; j < journeyCheckpointList.length; j++) {
        // eslint-disable-next-line max-len
        setJourneyCheckpointArray((journeyCheckpointArray) => [...journeyCheckpointArray, journeyCheckpointList[j]]);
      }
      /* to get the audio details of the first journey meditation */
      if (i == 0) {
        const audioDetail = JSON.parse(journeyCheckpointList[0].content[0]);
        getDataStoreURL(audioDetail.audioFemale).then((response)=>{
          setJourneyCheckpointAudio(response);
        });
      }
    }
  };
  const getDataStoreURL = async (str) => {
    const url = await Storage.get(str);
    return url;
  };
  return (
    <div
      id="playVideoDiv"
      style={{
        display: journeyDemoVisibility ? 'inline' : 'none',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        zIndex: '200',
      }}
    >
      <div
        onClick={() => {
          setJourneyDemoVisibility(false);
          setShowAll(true);
        }}
        id="hideVideoBtn"
        style={{display: 'table', margin: '70px auto 50px auto'}}>
        <p
          style={{
            color: '#555',
            backgroundColor: '#fafafa',
            padding: '5px 14px 6px 14px',
            borderRadius: '50px',
            fontSize: '24px',
            cursor: 'pointer',
          }}
        >
              ⨉
        </p>
      </div>

      {showAll ?
      <MeditationPopupTable cellspacing="0" cellpadding="0">
        <colgroup>
          <MeditationPopupTableCol1 />
          <MeditationPopupTableCol2 />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div>
                <div style={{padding: '50px'}}>
                  <table>
                    <tr>
                      <td>
                        <ChillfulActivityListIcon
                          src={require('../images/general/mindful_icon_original.png')}
                        />
                      </td>
                      <td>
                        <ChillfulActivityListStyle2ClassBottomText1>
                          {journeyArray.nameChi}
                        </ChillfulActivityListStyle2ClassBottomText1>
                      </td>
                    </tr>
                  </table>
                  <p
                    style={{
                      fontSize: '28px',
                      fontWeight: '600',
                      marginTop: '3px',
                    }}
                  >
                    第{activeKey + 1}節：
                    {
                      journeyCheckpointArray[0] && journeyCheckpointArray[activeKey].nameChi
                    }
                  </p>
                  {journeyCheckpointAudio &&
                    <BannerAudio key={activeKey} style={{width: '90%'}} controls>
                      <source src={activeKey == 0 && journeyCheckpointAudio} type="audio/ogg" />
                      <source src={activeKey == 0 && journeyCheckpointAudio} type="audio/mpeg" />
                    </BannerAudio>
                  }
                  <div
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      display: 'inline-block',
                    }}
                  >
                    {journeyImageArray && journeyImageArray.map((item, i) =>
                      <>
                        <div
                          onClick={() => setActiveKey(i)}
                          key={i}
                          style={{
                            width: 60,
                            height: 60,
                            marginRight: 15,
                            display: 'inline-block',
                            border: '1px solid red',
                            borderRadius: 10,
                            cursor: 'pointer',
                            backgroundImage: 'url(' + item + ')',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            border: i == activeKey ? '2px solid #FF9400' : '2px solid white',
                          }}
                        >
                          {i != 0 &&
                          <svg
                            style={{
                              zIndex: '3',
                              position: 'absolute',
                              marginTop: 4,
                              marginLeft: 2,
                            }}
                            width="15px"
                            height="15px"
                            viewBox="0 0 464 592"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Path</title>
                            <g id="Mindful-Explore" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="Group-14" transform="translate(40.000000, 40.000000)">
                                <rect id="Rectangle" stroke="#979797" fill="#FFFFFF" x="143.5" y="277.5" width="92" height="148"></rect>
                                <g id="padlock" fill="#777777" fillRule="nonzero" stroke="#FFFFFF" strokeWidth="40">
                                  <path d="M192,-20 C232.811,-20 269.815378,-3.41289333 296.614136,23.3858644 C323.144906,49.9166345 339.667237,86.449933 339.99503,126.776818 L340,128 L340,172.116 L340.647501,172.157005 C357.32398,173.287316 372.380101,180.454118 383.625479,191.4972 L384.067391,191.935119 C396.233954,204.101682 403.817919,220.846449 403.996765,239.331126 L404,240 L404,464 C404,482.749398 396.380539,499.751733 384.067391,512.064881 C371.896189,524.236083 355.14556,531.81797 336.668589,531.996766 L336,532 L48,532 C29.2587342,532 12.2504523,524.382724 -0.0673911654,512.064881 C-12.2339537,499.898318 -19.8179191,483.153551 -19.9967654,464.668874 L-20,464 L-20,240 C-20,221.250602 -12.3805388,204.248267 -0.0673911654,191.935119 C11.2239653,180.643763 26.4565931,173.302189 43.3524989,172.157005 L44,172.116 L44,128 C44,87.59711 60.2570232,50.9250903 86.5849715,24.1928824 L87.3858644,23.3858644 C113.916635,-3.14490575 150.449933,-19.6672367 190.776818,-19.9950302 L192,-20 L192,-20 Z M192,297.333333 C185.749667,297.333333 180.087378,299.882227 175.984802,303.984802 C171.882227,308.087378 169.333333,313.749667 169.333333,320 C169.333333,332.081896 179.099395,341.665487 190.666667,342.581393 L190.666667,342.581393 L190.666667,405.333333 L190.675569,405.489146 C190.710865,405.795931 190.849219,406.071616 191.056708,406.279105 C191.297965,406.520362 191.632143,406.666667 192,406.666667 C192.367857,406.666667 192.702035,406.520362 192.943292,406.279105 C193.185362,406.037035 193.333333,405.702142 193.333333,405.333333 L193.333333,405.333333 L193.333333,342.581393 L193.686862,342.550654 C205.098896,341.469644 214.666667,331.958612 214.666667,320 C214.666667,313.749667 212.117773,308.087378 208.015198,303.984802 C203.912622,299.882227 198.250333,297.333333 192,297.333333 Z M192,62.6666667 C173.984333,62.6666667 157.655378,69.99956 145.827469,81.827469 C133.99956,93.6553779 126.666667,109.984333 126.666667,128 L126.666667,128 L126.666667,172 L257.333333,172 L257.333333,128 L257.329986,127.33353 C257.151589,109.581835 249.854416,93.5093543 238.172531,81.827469 C226.344622,69.99956 210.015667,62.6666667 192,62.6666667 Z" id="Shape"></path>
                                </g>
                              </g>
                            </g>
                          </svg>
                          }
                        </div>
                      </>,
                    )}
                  </div>
                  {activeKey != 0 &&
                    <div>
                      <LockText style={{color: '#333'}}>*此章節已上鎖。
                        <DownloadVivableeText
                          onClick={()=>{
                            if (isDesktop) {
                              setShowAll(false);
                            } else {
                              isIOS ? toDownloadAppIOS() : toDownloadAppAndroid();
                            }
                          }}
                        >
                          立即下載 Vivablee
                        </DownloadVivableeText>
                        ，解鎖所有章節！
                      </LockText>
                    </div>
                  }
                </div>
              </div>
            </td>
            <MeditationPopupTableTd2>
              {activeKey != 0 &&
                <center>
                  <p style={{fontSize: 18, marginRight: 40, marginTop: 10}}>立即下載 Vivablee</p>
                </center>
              }
              <div
                style={{
                  marginTop: activeKey == 0 ? 40 : 0,
                  marginBottom: activeKey == 0 ? 40 : 0,
                  marginRight: 40,
                  width: activeKey == 0 ? 250 : 200,
                  height: activeKey == 0 ? 250 : 200,
                  borderRadius: 20,
                  backgroundImage: activeKey == 0 ? 'url(' + journeyImageArray[0] + ')' : `url(${QRCode})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              {activeKey != 0 &&
                <center>
                  <p style={{fontSize: 18, marginRight: 40}}>解鎖所有章節</p>
                </center>
              }
            </MeditationPopupTableTd2>
          </tr>
        </tbody>
      </MeditationPopupTable> :
      <center>
        <QRCodeDiv>
          <p style={{fontSize: 18, marginTop: 10}}>立即下載 Vivablee</p>
          <center>
            <div
              style={{
                marginTop: 0,
                marginBottom: 0,
                width: 200,
                height: 200,
                borderRadius: 20,
                backgroundImage: `url(${QRCode})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          </center>
          <p style={{fontSize: 18}}>解鎖所有章節</p>
        </QRCodeDiv>
      </center>
      }
    </div>
  );
}

export default JourneyDemo;

JourneyDemo.propTypes = {
  id: PropTypes.string,
  journeyDemoVisibility: PropTypes.bool,
  setJourneyDemoVisibility: PropTypes.func,
};

const MeditationPopupTable = styled.table`
  border-radius: 20px;
  width: calc( 100% );
  background-color: white;
  max-width: 1000px;
  margin: 0px auto;
  border-spacing: 0px;
  border-collapse: 0px;
  @media only screen and (max-width: 1200px) {
    width: 900px;
  }
  @media only screen and (max-width: 1024px) {
    width: 700px;
  }
  @media only screen and (max-width: 768px) {
    width: calc(100% - 40px);
  }
  @media only screen and (max-width: 480px) {
    width: calc(100% - 40px);
  }
`;

const QRCodeDiv = styled.div`  
  border-radius: 20px;
  background-color: white;
  border-spacing: 0px;
  border-collapse: 0px;
  padding: 40px;
  width: 240px;
  text-align: center;
`;

const ChillfulActivityListIcon = styled.img`
  height: 12px;
  margin-right: 2px;
  margin-top: 6px;
`;

const ChillfulActivityListStyle2ClassBottomText1 = styled.div`
  font-size: 14px;
  color: #ff9400;
  font-weight: 700;
`;

const BannerAudio = styled.audio`
  margin-top: 20px;
  width: 500px;
  @media only screen and (max-width: 1025px) {
    width: 90%;
  }
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
  @media only screen and (max-width: 480px) {
    width: 90%;
  }
`;

const MeditationPopupTableCol1 = styled.col`
  width: calc( 100% - 250px );
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const MeditationPopupTableCol2 = styled.col`
  width: 250px;
  @media only screen and (max-width: 768px) {
    width: 0;
  }
`;

const MeditationPopupTableTd2 = styled.td`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const DownloadVivableeText = styled.span`
cursor: pointer;
text-decoration: underline;
transition: 0.5s;
  :hover {
    color: #ff9700;
  }
`;

const LockText = styled.p`
  @media only screen and (min-width: 769px) {
    display: none;
  }
`;
